import 'react-app-polyfill/ie9'
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import React from 'react';
import { Provider } from 'react-redux';
import { render } from 'react-dom';
import './i18n';
import App from './components/App';
import store from './redux/store';


render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('app')
);
